import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsBoolean, IsString, IsUUID, MaxLength } from 'class-validator';
import { UserDto } from '../../user/dto/user.dto';

import { RepairPaymentPaidInterface } from '../interfaces/repair-payment-paid.interface';
import { UserPublicInterface } from '../../user/interfaces/user-public.interface';
import { RepairPaymentInterface } from '../../repair-payment/interfaces/repair-payment.interface';
import { RepairPaymentDto } from '../../repair-payment/dto/repair-payment.dto';

@Exclude()
export class RepairPaymentPaidDto
  extends CommonEntityDto
  implements RepairPaymentPaidInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase Bump ID',
  })
  @IsUUID()
  @Expose()
  repairPaymentId!: string;

  @ApiProperty({
    title: 'Paid',
    type: 'boolean',
  })
  @IsBoolean()
  @Expose()
  paid!: boolean;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this job phase bump note.',
  })
  @Expose()
  user?: UserPublicInterface | undefined;

  @ApiPropertyOptional({
    type: () => [RepairPaymentDto],
    title: 'Job Phase Bump',
    description: 'The Job Phase Bump associated with this job phase bump note.',
  })
  @Expose()
  repairPayment?: RepairPaymentInterface | undefined;
}
